/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import { getAssets } from "@unisearch/helpers";
import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import API from "@unisearch/helpers/api";
import styles from "./comments.module.scss";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";
import { useSystemActions } from "@_recoil/_actions";
import { useRouter } from "next/router";
import { TextareaAutosize } from "@mui/material";
import CommentTextBox from "./comment_text_box";

export const CommentsComponent = ({ postSlug, groupSlug, commentType }) => {
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();
  const [commentsList, setCommentsList] = useState([]);
  const [replyItem, setReplyItem] = useState(false);
  const router = useRouter();

  //load ocmments
  const loadComment = async () => {
    await API.post(`/public/forum-comment/get/${postSlug}/${groupSlug}`, {
      filter: {},
      sortOrder: "DESC",
      sortField: "id",
      pageNumber: 1,
      pageSize: 10,
    }).then((resp) => {
      if (!resp.error) {
        setCommentsList(resp.data.results);
        setReplyItem(false);
      }
    });
  };

  //Reply Actions
  const replyAction = (parentId) => {
    if (profileInfo && profileInfo.userTypeSlug !== "") {
      if (parentId && parentId != "") {
        setReplyItem(parentId);
      }
    } else {
      systemActions.setReturnUrl(router.asPath);
      router.push({ pathname: "/signin" });
    }
  };

  useEffect(() => {
    if (postSlug && groupSlug) {
      loadComment();
    }
  }, [groupSlug, postSlug]);

  const RenderCommentList = (data, nestedNum = 0) => {
    if (data && data.length > 0) {
      return (
        <ul className={styles.comments}>
          {data.map((item, index) => {
            return (
              <>
                <li className={styles.comment_single} key={index}>
                  <div className={styles.comment_avatar}>
                    <img
                      src={
                        item?.userInfo?.profileImageSrc ??
                        getAssets("assets/student-avatar-big.png")
                      }
                      alt={item?.userInfo?.fullName}
                    />
                  </div>
                  <div className={styles.comment_description}>
                    <div className={styles.comment_basic_info}>
                      <h4 className={styles.comment_name}>
                        {item?.userInfo?.fullName}
                      </h4>
                      <div className={styles.comment_time}>1 Day Ago</div>
                      {nestedNum < 2 && (
                        <button
                          className={styles.comment_reply}
                          onClick={() => replyAction(item?.id)}
                        >
                          Reply
                        </button>
                      )}
                    </div>
                    <div className={styles.comment_text}>{item?.content}</div>
                    {item.children &&
                      item.children.length > 0 &&
                      RenderCommentList(item.children, parseInt(nestedNum + 1))}

                    {replyItem &&
                      replyItem === item.id &&
                      profileInfo &&
                      profileInfo.userTypeSlug !== "" && (
                        <CommentTextBox
                          profileInfo={profileInfo}
                          groupSlug={groupSlug}
                          postSlug={postSlug}
                          parentId={replyItem}
                          loadComment={() => loadComment()}
                        />
                      )}
                  </div>
                </li>
              </>
            );
          })}
        </ul>
      );
    }
  };

  return (
    <>
      <div className={styles.comment_count_wrapper}>
        <span className={styles.comment_count_icon}>
          <ReactSVG src={"/assets/icons/group-chat.svg"} />
        </span>
        <span className={styles.comment_num}>24 Comments</span>
      </div>

      {commentsList &&
        commentsList.length > 0 &&
        RenderCommentList(commentsList)}

      {profileInfo && profileInfo.userTypeSlug != "" && (
        <CommentTextBox
          profileInfo={profileInfo}
          groupSlug={groupSlug}
          postSlug={postSlug}
          parentId={0}
          commentType={commentType}
          loadComment={() => loadComment()}
        />
      )}
    </>
  );
};

export default CommentsComponent;
